var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rating !== null),expression:"rating !== null"}]},[_vm._l((_vm.stars),function(value,index){return _c('img',{key:index,class:_vm.starClass,attrs:{"src":value}})}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }